import Vue from "vue/dist/vue.esm";

var normalAthletes = Vue.extend({
  data() {
    return {
      KEIRIN_SALE_STATUS: chari.const.KEIRIN_SALE_STATUS,
      isClickable: false
    }
  },
  template: `
  <table class="text-nowrap table table-vote-number table-align-middle">
    <thead class="bg-gray-lighter text-bold">
      <tr class="bg-gray-lighter">
        <th height="68">予想</th>
        <th>枠番</th>
        <th>車番</th>
        <th>選手名</th>
        <th>競走得点</th>
        <th>年齢</th>
        <th>府県</th>
        <th>期別</th>
        <th>級班</th>
        <th>脚質</th>
        <th>ギア倍数</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(athlete, key, index) in raceInfo.race_athletes" :class="['bg-lighten-' + athlete.entry_num, {'is-disabled': !athlete.on_sale}, {'is-clickable': isClickable}]" @click="addSyabanToEditCart(raceInfo.box.race_num, athlete.entry_num)" :key="athlete.id">
        <td height="68" class="bg-white text-center">
          <span v-if="raceInfo.prediction.marks">{{raceInfo.prediction.marks[index]}}</span>
        </td>
        <td :rowspan="joiningWakuNum(athlete.waku_num)" v-if="isFirstWaku(key)" class="bg-white  text-center">{{athlete.waku_num}}</td>
        <td :class="'bg-' + athlete.entry_num" class="text-center text-bold">{{athlete.entry_num}}</td>
        <td>
          <a :href="athlete.profile_url" target="_blank" class="" :class="{'text-through': !athlete.on_sale}">{{athlete.name}}</a>
          <span v-if="!athlete.on_sale">（取消）</span>
        </td>
        <td>{{athlete.average_point_formatted}}</td>        
        <td>{{athlete.age}}</td>
        <td>{{athlete.pref_name}}</td>
        <td>{{athlete.graduate_period}}</td>
        <td>{{athlete.class_name}}{{athlete.group_name}}</td>
        <td>{{athlete.leg_quality}}</td>
        <td>
          <p class="text-through text-base">{{athlete.gear_ratio_before || ''}}</p>
          {{athlete.gear_ratio}}
        </td>
      </tr>
    </tbody>
  </table>
  `,
  methods: {
    hasPopupData: function() {
      if (!this.hasOwnProperty(popupData)) {
        return true;
      }
      
      return false;
    },
    addSyabanToEditCart: function(race_num, syaban) {
      this.$parent.$emit('addSyaban', race_num, syaban);
    },
    computeAvePoint: function(num) {
      return (Math.floor(num / 10) / 100).toPrecision(4);
    },
    // 同一の枠番がいくつ有るかを出力
    joiningWakuNum: function(num) {
      var race_athelets = this.raceInfo.race_athletes;
      var waku_nums = [];
      
      for (var key in race_athelets) {
        waku_nums.push(race_athelets[key].waku_num);
      }
      
      var count = 0;
      for (var i=0; i<waku_nums.length; i++) {
        count = (waku_nums[i] == num) ? count + 1 : count;
      }
      
      return count;
    },
    // 指定した車番の選手が同一枠番の最初かどうかの判定
    isFirstWaku: function(syaban) {
      var race_athelets = this.raceInfo.race_athletes;
      var waku_nums = [];
      var syabans = Object.keys(race_athelets);
      
      for (var key in race_athelets) {
        waku_nums.push(race_athelets[key].waku_num);
      }
      
      var targetIndex = waku_nums.indexOf(race_athelets[syaban].waku_num);
      
      if (syaban == syabans[targetIndex]) {
        return true;
      } else {
        return false;
      }
    }
  }
});

export default {
  normalAthletes
}
